import { BaseModel } from '@tcc-mono/shared/data-access';

export class WebNotification extends BaseModel {
  id: number;
  title: string;
  content?: string | null;
  send_email?: boolean;
  email_send_at?: string | null;
  show_web?: boolean;
  link?: string | null;
  handled_at?: string | null;
  handled_by_user_id?: number | null;
  created_at?: string;
}

export interface WebNotificationInbox {
  unhandled: WebNotification[];
  handled: WebNotification[];
  unhandled_count: number;
}
